<template>
    <div>
        <span v-if="error != null">{{error}}</span>
        <span v-else-if="isAlreadyRated == true">{{ message | trans}}</span>
        <span v-else >
            <form class="form-inline" @submit.prevent="rate">
                <input type="hidden" id="uniqueId" name="uniqueId" v-model="uniqueId">
                <div class="form-row">
                    <div class="col-auto">
                        <select class="form-control" v-model="rating">
                            <option value="5">5 {{ 'revisions.stars' | trans_choice(5) }}</option>
                            <option value="4">4 {{ 'revisions.stars' | trans_choice(4) }}</option>
                            <option value="3">3 {{ 'revisions.stars' | trans_choice(3) }}</option>
                            <option value="2">2 {{ 'revisions.stars' | trans_choice(2) }}</option>
                            <option value="1">1 {{ 'revisions.stars' | trans_choice(1) }}</option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <button type="submit" class="btn btn-primary ml-2">{{ 'revisions.rate' | trans }}</button>
                    </div>
                </div>
            </form>
        </span>
    </div>
</template>

<script>

export default {
    props: {
        entry: {
            type: Number,
            required: true
        },
        alreadyrated: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    methods: {
        rate: function(){
            axios.post("/entries/rate/"+this.entry, {
                rating: this.rating,
                uniqueId: this.uniqueId
            })
                .then(response => {
                    this.isAlreadyRated = true;
                    this.message = "rating.thanks_for_rating";
                })
                .catch(error => {
                    this.error = error.response.data.error;
                });
        }
    },
    data: function() {

        if(this.$cookies.get("uniqueId") === null) {
          let randomNumber = Math.floor(Math.random() * 500);
          this.$cookies.set("uniqueId", Date.now() + randomNumber, "7d");
        }

        console.log(this.$cookies.get("uniqueId"));

        return {
            uniqueId: this.$cookies.get("uniqueId"),
            rating: "5",
            isAlreadyRated: this.alreadyrated,
            message: "rating.already_rated",
            error: null,
        }
    }
}
</script>